import React, {useState, useEffect, useRef} from 'react'
import {useLocation, useOutletContext} from "react-router-dom";
import ReceiptModal from '../Components/ReceiptModal'
import RightSidebar from '../Components/RightSidebar'

import api from '../utils/api'
import InvoiceSettingsModal from "../Components/InvoiceSettingsModal";
import ProductModal from "../Components/ProductModal";
import InvoiceTypeModal from "../Components/InvoiceTypeModal";
import {dateFormat, priceFormat, showError, processAxiosError} from '../utils/helper'
import global from '../global';

import ProductBox from "../Components/ProductBox";
import NoResults from "../Components/NoResults";
import ProductLoading from "../Components/ProductLoading";
import Pagination from "../Components/Pagination";
import beepSound from '../assets/sound/beep-29.mp3';
import beepButton from '../assets/sound/button-21.mp3';
import HeaderTop from "../Components/HeaderTop";
import AdminNoticesBar from "../Components/AdminNoticesBar";
import LoyaltyModal from "../Components/LoyaltyModal";

const ProductMode = (props) => {
    const { showSelectPosModal } = useOutletContext() || {};

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const [meta, setMeta] = useState({})
    const [links, setLinks] = useState({})
    const location = useLocation();
    const {hash, pathname} = location;
    const {mode} = props;
    const [loading, setLoading] = useState(false)
    const [product, setProduct] = useState({})
    const [cartItems, setCartItems] = useState([])
    const [cash, setCash] = useState(0)
    const [change, setChange] = useState(0)
    const [showReceiptModal, setShowReceiptModal] = useState(false)
    const [showInvoiceSettingsModal, setShowInvoiceSettingsModal] = useState(false)
    const [receipt, setReceipt] = useState({})
    const [paymentMethod, setPaymentMethod] = useState('G')
    const [note, setNote] = useState('')
    const [invoiceType, setInvoiceType] = useState('G')
    const [printType, setPrintType] = useState('T')
    const [invoiceCompany, setInvoiceCompany] = useState({
        company: '',
        oib: '',
        address: '',
        zip: '',
        city: '',
        country: 'Hrvatska'
    })
    const [showInvoiceTypeModal, setShowInvoiceTypeModal] = useState(false)
    const [discountAmount, setDiscountAmount] = useState(0.00)
    const [discountPercent, setDiscountPercent] = useState(0)
    const [discountActive, setDiscountActive] = useState(false)
    const [showProductModal, setShowProductModal] = useState(false)
    const [showLoyaltyModal, setShowLoyaltyModal] = useState(false)
    const [loyaltyData, setLoyaltyData] = useState(null)
    // Mjerodavan izracun loyalty popusta sa servera (LoyaltyService::quote()).
    // Blagajna ga NE racuna sama — prikazuje i naplacuje ono sto server vrati.
    const [loyaltyQuote, setLoyaltyQuote] = useState(null)
    const loyaltyQuoteSeq = useRef(0)

    const [scanActive, setScanActive] = useState(true)

    const [search, setSearch] = useState('')

    const [currentPage, setCurrentPage] = useState(1)

    // Audio refs to prevent memory leaks
    const beepAudioRef = useRef(null)
    const buttonAudioRef = useRef(null)

    useEffect(() => {
        beepAudioRef.current = new Audio(beepSound)
        buttonAudioRef.current = new Audio(beepButton)

        return () => {
            beepAudioRef.current = null
            buttonAudioRef.current = null
        }
    }, [])

    const handleScan = (barcodeString) => {
        getProduct(barcodeString).then(r => {
            if (r) {
                setShowProductModal(true)
            }
        })
    }

    useEffect(() => {
        let barcodeScanBuffer = '';
        let barcodeTimeout = null;

        function handleKeyDown(e) {
            if (e.keyCode === 13 && barcodeScanBuffer.length === 20) {
                handleScan(barcodeScanBuffer)
                barcodeScanBuffer = '';
                return;
            }

            barcodeScanBuffer += e.key;

            if (barcodeTimeout) {
                clearTimeout(barcodeTimeout);
            }

            barcodeTimeout = setTimeout(() => {
                barcodeScanBuffer = '';
            }, 500);
        }

        if (scanActive === true && !showLoyaltyModal) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
            if (barcodeTimeout) {
                clearTimeout(barcodeTimeout);
            }
        }
    }, [scanActive, showLoyaltyModal])

    useEffect(() => {
        clearAll();
    }, [mode]);

    const barcodeScanner = () => {

        if (scanActive) {
            setScanActive(false);
        } else {
            setScanActive(true);
        }
    }

    const showProduct = (product) => {

        setProduct(product)
        setShowProductModal(true)
    }

    async function getProduct(id, {signal} = {}) {
        setLoading(true)


        return window.axios.get(`/products/${id}`, {signal})
            .then(response => {

                if (response && response.data) {
                    setProduct(response.data.data)
                }
                return response
            })
            .catch((error) => {
                console.log(error.toJSON());
                showError('Došlo je do greške!')
            })
            .finally(() => setLoading(false))
    }


    const runSearch = (value) => {
        setSearch(value)
        setCurrentPage(1) // Reset to first page on new search
    }

    const fetchData = async () => {
        setIsLoading(true)
        try {
            let fetchUrl = `/products?page=${currentPage}&search=${search}`;
            const result = await window.axios.get(fetchUrl)

            setProducts(result.data.data)
            setMeta(result.data.meta)
            setLinks(result.data.links)
        } catch (error) {
            showError('Greška pri učitavanju proizvoda.')
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        // Don't fetch products until invoice device is selected
        if (showSelectPosModal) {
            setProducts([])
            setIsLoading(false)
            return
        }
        fetchData()
    }, [search, currentPage, showSelectPosModal])

    useEffect(() => {
        updateChange()

    }, [cash, cartItems])

    const beep = () => {
        if (beepAudioRef.current) {
            beepAudioRef.current.currentTime = 0
            beepAudioRef.current.play().catch(() => {})
        }
    }

    const clearSound = () => {
        if (buttonAudioRef.current) {
            buttonAudioRef.current.currentTime = 0
            buttonAudioRef.current.play().catch(() => {})
        }
    }

    const calcDiscount = (value, type) => {
        value = parseFloat(value)

        // If empty or invalid input, reset discount to 0
        if (isNaN(value) || value === '' || value < 0) {
            setDiscountPercent(0)
            setDiscountAmount(0)
            return;
        }

        let total = parseFloat(getTotalPrice());

        if (type === "percent") {
            if (value > 100) {
                value = 100;
            }
            setDiscountPercent(value)

            if (cartItems.length) {
                let amount = total * (value / 100)
                amount = (Math.round(amount * 100) / 100).toFixed(2);
                setDiscountAmount(amount)
            }

        } else {
            if (value > total) {
                // value = total;
                // setDiscountPercent(100)
                // setDiscountAmount(value)
            } else {
                let amount = (value / total) * 100
                amount = (Math.round(amount * 100) / 100).toFixed(2);
                setDiscountAmount(value)
                setDiscountPercent(amount)
            }
        }
    }
    const getItemsTotal = () => cartItems.reduce(
        (total, item) => total + (item['quantity'] * (
            item['use_override_price'] === true ? item['override_price_with_tax'] : item['price_with_tax'] || 0)), 0
    )

    // Base total without any loyalty discount (but with manual discount).
    // Mora biti IDENTICNA osnovici koju /sales izracuna iz payloada (total - discount):
    // zbroj stavki zaokruzen na 2 decimale minus rucni popust. Rucni popust se oduzima
    // bezuvjetno — discountActive je samo prekidac panela, a iznos ide na server i kad je
    // panel zatvoren, pa bi uvjetovanje njime razislo blagajnu i racun za cijeli popust.
    const getBaseTotal = () => {
        const itemsTotal = parseFloat(getItemsTotal().toFixed(2))
        const total = itemsTotal - (parseFloat(discountAmount) || 0)
        // Preserve negative totals in return mode; only clamp when discount pushes a positive total below zero.
        return itemsTotal < 0 ? total : Math.max(0, total)
    }

    // Loyalty popust se NE racuna na blagajni — mjerodavan je iznos koji vrati server,
    // isti onaj po kojem ce se izdati racun. Dok kotacija nije stigla, popusta nema.
    const getLoyaltyDiscount = () => {
        if (!loyaltyData || !loyaltyQuote) return 0

        return parseFloat(loyaltyQuote.total_discount) || 0
    }

    const getTotalPrice = (discount = false) => {

        const itemsTotal = getItemsTotal()

        if (discount) {
            const total = getBaseTotal() - getLoyaltyDiscount()
            // Preserve negative totals in return mode; only clamp when discount/loyalty push a positive total below zero.
            return (itemsTotal < 0 ? total : Math.max(0, total)).toFixed(2)
        }

        return itemsTotal.toFixed(2)
    }

    // Total with manual discount but WITHOUT loyalty (for loyalty calculation)
    const getTotalForLoyalty = () => {
        return getBaseTotal().toFixed(2)
    }

    /**
     * Povuci mjerodavan loyalty izracun sa servera.
     * Vraca kotaciju (ili null ako nije uspjela) kako bi je pozivatelj mogao upotrijebiti
     * ODMAH — React state se osvjezi tek u sljedecem renderu, a naplata ne smije cekati.
     */
    const fetchLoyaltyQuote = async (data = loyaltyData) => {
        if (!data || !data.memberId) {
            setLoyaltyQuote(null)
            return null
        }

        const seq = ++loyaltyQuoteSeq.current
        const base = parseFloat(getBaseTotal().toFixed(2))

        // Povrat ili nulta osnovica: server loyalty ionako ne primjenjuje, a /loyalty/calculate
        // ne prima negativan iznos. Vracamo praznu kotaciju da zahtjev ne padne i ne blokira naplatu.
        if (!(base > 0)) {
            const emptyQuote = {
                base_total: base, vip_percent: 0, vip_discount: 0,
                coupon_code: null, coupon_id: null, coupon_discount: 0,
                points_spend: 0, points_discount: 0,
                total_discount: 0, total_to_charge: base, errors: {},
            }

            if (seq === loyaltyQuoteSeq.current) setLoyaltyQuote(emptyQuote)

            return emptyQuote
        }

        try {
            const {data: response} = await window.axios.post('/loyalty/calculate', {
                member_id: data.memberId,
                total: base,
                points_to_spend: data.pointsToSpend || 0,
                coupon_code: data.couponCode || null,
                apply_vip: !!data.vipActive,
            })

            const quote = response?.data?.quote || null

            // Zanemari odgovor koji je u meduvremenu pretekao noviji zahtjev.
            if (seq === loyaltyQuoteSeq.current) setLoyaltyQuote(quote)

            return quote
        } catch (e) {
            if (seq === loyaltyQuoteSeq.current) setLoyaltyQuote(null)
            processAxiosError(e)

            return null
        }
    }

    // Promjena kosarice, rucnog popusta ili loyalty ulaza -> kotacija se mora osvjeziti.
    useEffect(() => {
        if (!loyaltyData) {
            setLoyaltyQuote(null)
            return
        }

        const timer = setTimeout(() => fetchLoyaltyQuote(), 150)

        return () => clearTimeout(timer)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartItems, discountAmount, loyaltyData])

    const getCartItems = () => {

        return cartItems.map(({
                                  id,
                                  product_attribute_id,
                                  code,
                                  quantity,
                                  name,
                                  product_attribute_name,
                                  price,
                                  price_tax,
                                  price_with_tax,
                                  tax_rate,
                                  override_price_with_tax,
                                  override_price_with_tax_f,
                                  use_override_price,
                                  use_wholesale_price,
                                  reduction_price,
                                  reduction_price_tax,
                                  reduction_price_with_tax,
            kpd
                              }) => ({
            id,
            product_attribute_id,
            code,
            quantity,
            name,
            product_attribute_name,
            price,
            price_tax,
            price_with_tax,
            tax_rate,
            override_price_with_tax,
            override_price_with_tax_f,
            use_override_price,
            use_wholesale_price,
            reduction_price,
            reduction_price_tax,
            reduction_price_with_tax,
            kpd
        }));

    }

    const addToCart = (product, useReductionPrice) => {


        if (useReductionPrice) {
            product.use_override_price = true
            product.override_price_with_tax = product.reduction_price_with_tax;
            product.override_price_with_tax_f = priceFormat(product.reduction_price_with_tax);
        } else {
            product.use_override_price = false
        }

        const exist = cartItems.find((item) => item.code === product.code)

        if (product.stock_quantity < (exist ? (exist.quantity + 1) : 1) && product.sell_without_stock === 0) {
            showError('Nedovoljna količina proizvoda na skladištu!')
            return;
        }

        if (exist) {
            setCartItems(
                cartItems.map((item) =>
                    item.code === product.code ? {...exist, quantity: exist.quantity + 1} : item
                )
            )
        } else {
            setCartItems([...cartItems, {...product, quantity: 1}])
        }
        removeDiscount()
        beep();
    }
    const addToCartWholesale = (product, price) => {

        price = String(price).replace(',', '.');

        product.use_override_price = true
        product.use_wholesale_price = true
        product.override_price_with_tax = parseFloat(price);
        product.override_price_with_tax_f = priceFormat(parseFloat(price));
        product.tax_rate = 0;

        const exist = cartItems.find((item) => item.code === product.code)

        if (product.stock_quantity < (exist ? (exist.quantity + 1) : 1) && product.sell_without_stock === 0) {
            showError('Nedovoljna količina proizvoda na skladištu!')
            return;
        }

        if (exist) {
            setCartItems(
                cartItems.map((item) =>
                    item.code === product.code ? {...exist, quantity: exist.quantity + 1} : item
                )
            )
        } else {
            setCartItems([...cartItems, {...product, quantity: 1}])
        }
        removeDiscount()
        beep();
    }
    const addToCartReturn = (product, price) => {

        price = price.replace(',', '.');

        if (product.price_with_tax !== parseFloat(price)) {
            product.use_override_price = true
            product.override_price_with_tax = parseFloat(price);
            product.override_price_with_tax_f = priceFormat(parseFloat(price));
        } else {
            product.use_override_price = false
        }

        const exist = cartItems.find((item) => item.code === product.code)

        if (exist) {
            setCartItems(
                cartItems.map((item) =>
                    item.code === product.code ? {...exist, quantity: exist.quantity - 1} : item
                )
            )
        } else {
            setCartItems([...cartItems, {...product, quantity: -1}])
        }
        removeDiscount()
        beep();
    }
    const removeDiscount = () => {

        setDiscountAmount(0.00);
        setDiscountPercent(0)
        setDiscountActive(false)

    }

    const removeFromCart = (product) => {
        const exist = cartItems.find((item) => item.code === product.code)
        if (exist.quantity === 1) {
            setCartItems(cartItems.filter((item) => item.code !== product.code))
            clearSound()
        } else {
            setCartItems(
                cartItems.map((item) =>
                    item.code === product.code ? {...exist, quantity: exist.quantity - 1} : item
                )
            )
            beep()
        }
    }

    const updateChange = () => {

        setChange(parseFloat(cash) - getTotalPrice(true))
    }

    const addCash = (amount) => {
        setCash(parseFloat(cash) + parseFloat(amount))
        beep()
    }

    const inputCash = (amount) => {
        setCash(amount.toString().replace(',', '.'))
        beep()
    }

    const clearCart = () => {
        setCartItems([])
        clearSound()
    }

    const finish = () => {
        const time = new Date();

        if (discountPercent > global.invoiceDevice.max_discount) {

            showError("Maksimalan popust blagajne je " +  global.invoiceDevice.max_discount + "%");
            return;

        }
        //console.log(time)
        updateChange()
        setShowInvoiceSettingsModal(true)
    }
    const submit = () => {
        const time = new Date();
        setShowReceiptModal(true)
        setReceipt({
            receiptNo: `ACPOS-KS-${Math.round(time.getTime() / 1000)}`,
            receiptDate: dateFormat(time)
        })
    }

    const clearAll = () => {
        setShowReceiptModal(false)
        setShowInvoiceSettingsModal(false)
        setCartItems([])
        setReceipt({})
        setCash(0)
        setChange(0)
        setPaymentMethod('G')
        setInvoiceType('G')
        setNote('')
        setPrintType('T')
        setInvoiceCompany({
            company: '',
            oib: '',
            address: '',
            zip: '',
            city: '',
            country: 'Hrvatska'
        })
        removeDiscount()
        setLoyaltyData(null)
    }

    const handleLoyaltyApply = (data) => {
        setLoyaltyData(data)
    }

    function changePage(pageNumber) {
        setCurrentPage(pageNumber)
        //fetchData()
    }

    return (
        <>
            <HeaderTop displaySearch={true} runSearch={runSearch} scanActive={scanActive}
                       barcodeScanner={barcodeScanner}/>
             <AdminNoticesBar />


            <div className=" w-full h-full flex flex-column " style={{inHeight: `calc(100vh - 80px)`,}}>
                <div className="w-6/12 flex-grow flex">
                    <div className="flex flex-col bg-blue-gray-50 h-fit w-full">
                        <div className="h-full overflow-hidden mt-4">
                            {mode == "return" &&
                            <div className="d-flex  py-3 px-4 "><span className="text-xl font-semibold text-red-500">Povrat proizvoda</span>
                            </div>}
                            <div className="h-full overflow-y-auto px-2">

                                {(products.length === 0 && isLoading === false) &&
                                <NoResults/>
                                }

                                {(products.length === 0 && isLoading === true) &&

                                <div className="grid grid-cols-5 gap-4 pb-1">
                                    {
                                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                                            <ProductLoading key={item} className="w-full"/>
                                        ))
                                    }
                                </div>

                                }
                                {(products.length === 0) &&
                                <div></div>
                                }
                                <div className="grid grid-cols-5 gap-5 pb-3">
                                    {products.map(item => (
                                        <ProductBox key={'product-box-' + item.code} item={item}
                                                    showProduct={showProduct}/>
                                    ))}
                                </div>

                            </div>
                        </div>

                        {(products) &&

                        <Pagination meta={meta} changePage={changePage} currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}/>
                        }

                    </div>
                </div>
                <RightSidebar
                    mode={mode}
                    clearCart={clearCart}
                    removeFromCart={removeFromCart}
                    addToCart={addToCart}
                    addToCartReturn={addToCartReturn}
                    addToCartWholesale={addToCartWholesale}
                    cartItems={cartItems}
                    getTotalPrice={getTotalPrice}
                    getBaseTotal={getBaseTotal}
                    finish={finish}
                    discountAmount={discountAmount}
                    discountPercent={discountPercent}
                    discountActive={discountActive}
                    setDiscountActive={setDiscountActive}
                    calcDiscount={calcDiscount}
                    setShowInvoiceTypeModal={setShowInvoiceTypeModal}
                    loyaltyData={loyaltyData}
                    loyaltyQuote={loyaltyQuote}
                    onOpenLoyalty={() => setShowLoyaltyModal(true)}
                />
            </div>
            <InvoiceSettingsModal
                showInvoiceSettingsModal={showInvoiceSettingsModal}
                setShowInvoiceSettingsModal={setShowInvoiceSettingsModal}
                setShowReceiptModal={setShowReceiptModal}
                receipt={receipt}
                cartItems={cartItems}
                getTotalPrice={getTotalPrice}
                addCash={addCash}
                inputCash={inputCash}
                mode={mode}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                note={note}
                setNote={setNote}
                printType={printType}
                setPrintType={setPrintType}
                cash={cash}
                change={change}
                clearAll={clearAll}
                submit={submit}
                showReceiptModal={showReceiptModal}
                getCartItems={getCartItems}
                discountAmount={discountAmount}
                invoiceType={invoiceType}
                invoiceCompany={invoiceCompany}
                loyaltyData={loyaltyData}
                loyaltyQuote={loyaltyQuote}
                refreshLoyaltyQuote={fetchLoyaltyQuote}
                getBaseTotal={getBaseTotal}
            />
            <InvoiceTypeModal
                setShowInvoiceTypeModal={setShowInvoiceTypeModal}
                showInvoiceTypeModal={showInvoiceTypeModal}
                setInvoiceType={setInvoiceType}
                invoiceType={invoiceType}
                setInvoiceCompany={setInvoiceCompany}
                invoiceCompany={invoiceCompany}
                printType={printType}
                setPrintType={setPrintType}
            />

            <ProductModal
                mode={mode}
                addToCart={addToCart}
                addToCartReturn={addToCartReturn}
                addToCartWholesale={addToCartWholesale}
                showProductModal={showProductModal}
                setShowProductModal={setShowProductModal}
                product={product}
                setProduct={setProduct}
            />

            <ReceiptModal
                showReceiptModal={showReceiptModal}
                setShowReceiptModal={setShowReceiptModal}
                receipt={receipt}
                cartItems={cartItems}
                getCartItems={getCartItems}
                getTotalPrice={getTotalPrice}
                paymentMethod={paymentMethod}
                discountAmount={discountAmount}
                cash={cash}
                change={change}
                clearAll={clearAll}
            />

            <LoyaltyModal
                show={showLoyaltyModal}
                onClose={() => setShowLoyaltyModal(false)}
                onApply={handleLoyaltyApply}
                cartTotal={getTotalForLoyalty()}
                currentLoyaltyData={loyaltyData}
            />
        </>

    )
}

export default ProductMode;